// extracted by mini-css-extract-plugin
module.exports = {"content":"LootPackViews_content__3auAO","currencyAlert":"LootPackViews_currencyAlert__18xx5","price":"LootPackViews_price__x9HaK"};